import React, { useRef,Fragment } from 'react';
import { Form, Modal, FormGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { addCustomerTicket, getCustomerTicketList_Local } from '../store/api/CustomerApi';
import { useForm } from 'react-hook-form';
import { attachFile } from '../store/api/Services';
import { CheckLg, DashCircle } from 'react-bootstrap-icons';
import { setErrorDialog } from '../store/api/CommonFunctions';
const ModalNewTicket = (props) => {
    const frmTicket = useRef();
    const inputFile = useRef();
    const dispatch = useDispatch();
    const { register, errors, handleSubmit } = useForm();
    const { popData, setPopData } = props
    const { show, defaultSubject, formAttachmentID, formAttachmentType } = popData;

    const close = () => {
        setPopData({ show: false });
    }
    function addTicket(data) {
        data.FormAttachmentID = formAttachmentID;
        data.FormAttachmentType = formAttachmentType;
        const onSuccess = (res) => {
            setErrorDialog(dispatch,"success","ثبت تیکت");
            const id = res.ResponseID ? res.ResponseID : res.ID;
            attachFile(inputFile.current, id, "CustomerTicket", () => frmTicket.current?.reset())
            //For When Ticket Is New
            if (res.ID && res.TotalCount) {
                close();
                dispatch(getCustomerTicketList_Local({ ...res }));
            }
        }
        dispatch(addCustomerTicket(data, onSuccess));
    }
    return (
        <Modal show={show} size='lg' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>ثبت تیکت جدید<span onClick={close} style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faTimes} size="lg" /></span></Modal.Header>
            <Modal.Body>
                <form ref={frmTicket} onSubmit={handleSubmit(addTicket)} readOnly>
                    <FormGroup>
                        <label>موضوع: </label>
                        <Form.Control name="TicketSubject" ref={register({ required: true })} defaultValue={defaultSubject}/>
                        {errors.TicketSubject && <small className="erros">موضوع تیکت الزامی است</small>}
                    </FormGroup>
                    <FormGroup>
                        <label>شــرح: </label>
                        <Form.Control as="textarea" rows={3} name="TicketDesc" ref={register({ required: true })} />
                        {errors?.TicketDesc && <small className="errors">شرح تیکت الزامی است</small>}
                    </FormGroup>
                    <Fragment>
                        <Form.Group>
                            <label>پیوست: </label>
                            <input type="file" className="form-control" ref={inputFile} />
                        </Form.Group>
                        <div className="mt-2">
                            <Button className="group-Btn" variant="success" type="submit"><CheckLg size={15} />&nbsp;ثبت تیکت</Button>
                            <Button className="group-Btn" variant="danger" size="15" onClick={close}><DashCircle />&nbsp;انصراف</Button>
                        </div>
                    </Fragment>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalNewTicket;